module.exports = __webpack_public_path__ + "media/images/oak/payments-2bc3033d33d22859b506fb2b6d53d888.png";